;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

export type ListInvitationsForOrganizationQueryVariables = {
  organizationId: string
  after?: string | null
  before?: string | null
  first?: number | null
  last?: number | null
}

export type ListInvitationsForOrganizationInvitationNode = {
  id?: string | null
  userEmail?: string | null
  userFullName?: string | null
  pendingRole?: string | null
  createdAt?: string | null
  acceptedAt?: string | null
  revokedAt?: string | null
  expiresAt?: string | null
  invitedByUserId?: string | null
  organizationId?: string | null
  sendAttempts?: number | null
  tenantId?: string | null
  updatedAt?: string | null
}

export type ListInvitationsForOrganizationQueryData = {
  listInvitationsForOrganization?: {
    edges?: Array<{
      cursor?: string | null
      node?: ListInvitationsForOrganizationInvitationNode | null
    } | null> | null
    pageInfo?: {
      endCursor?: string | null
      hasNextPage?: boolean | null
      hasPreviousPage?: boolean | null
      startCursor?: string | null
    } | null
    totalCount?: number | null
  } | null
}

// Query to list all invitations for a specific organization
// Used by organization admins to see pending invitations
// Backend function: zest.list_invitations_for_organization
// Returns SETOF zest_hidden.organization_invitation
export const LIST_ORGANIZATION_INVITATIONS = gql`
  query ListInvitationsForOrganization(
    $organizationId: UUID!
    $after: Cursor
    $before: Cursor
    $first: Int
    $last: Int
  ) {
    listInvitationsForOrganization(
      iOrganizationId: $organizationId
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        cursor
        node {
          id
          userEmail
          userFullName
          pendingRole
          createdAt
          acceptedAt
          revokedAt
          expiresAt
          invitedByUserId
          organizationId
          sendAttempts
          tenantId
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`

export default LIST_ORGANIZATION_INVITATIONS
